import { Inbox, Menu, Reply, Sparkles, type LucideIcon } from "lucide-react";
import { haptik } from "../lib/mobil";

export type Tab = "antworten" | "posteingang" | "vorschlaege" | "mehr";

interface Props {
  aktiv: Tab;
  antwortenCount: number;
  ungelesenCount: number;
  vorschlaegeCount: number;
  onWahl: (tab: Tab) => void;
}

/**
 * Untere Navigation auf dem Telefon — dort, wo der Daumen ohnehin ist. Die
 * vier häufigsten Ziele direkt, alles Weitere hinter „Mehr" (der Seitenleiste).
 */
export function TabLeiste({ aktiv, antwortenCount, ungelesenCount, vorschlaegeCount, onWahl }: Props) {
  const tab = (id: Tab, label: string, Icon: LucideIcon, zahl = 0) => (
    <button
      type="button"
      className="tab-knopf"
      aria-current={aktiv === id ? "page" : undefined}
      onClick={() => { haptik(); onWahl(id); }}
    >
      <span className="tab-icon">
        <Icon aria-hidden="true" />
        {zahl > 0 && <span className="tab-zahl" aria-label={`${zahl} offen`}>{zahl > 99 ? "99+" : zahl}</span>}
      </span>
      <span className="tab-label">{label}</span>
    </button>
  );

  return (
    <nav className="tab-leiste" aria-label="Hauptbereiche">
      {tab("antworten", "Antworten", Reply, antwortenCount)}
      {tab("posteingang", "Posteingang", Inbox, ungelesenCount)}
      {tab("vorschlaege", "Vorschläge", Sparkles, vorschlaegeCount)}
      {tab("mehr", "Mehr", Menu)}
    </nav>
  );
}
